import React from 'react';
import { withRouter } from 'react-router';
import { Alert, Modal, Spinner } from 'react-bootstrap';
import { PageStatus } from 'enums';
import { Show } from 'Layout';
import { SurveysAPI } from "../../API";
import { formatDate } from "../../Utils/formatDate";
import { panelistDetailsDict } from 'Languages/SurveyTranslations';
type State = {
    survey: any,
    status: string,
    error: string | null,
};


class PanelistDetails extends React.Component<any, any> {
    // Hey! sonarqube, Please ignore this code
    // static defaultProps = {
    //     languageId: null,
    //     hideMenu: false,
    //     onUpdate: () => null,
    // };

    constructor(props) {
        super(props);
        this.state = {
            survey: null,
            status: PageStatus.None,
            error: null,
        };
    }

    componentDidMount() {
        if (this.props.id) {
            this.fetchSurvey();
        }
    }

    fetchSurvey() {
        Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => {
                if (!this.props.id) {
                    return Promise.reject(new Error('Invalid ID'));
                }
                return SurveysAPI.panelistOneSurvey(this.props.id);
            })
            .then((survey) => {
                if (survey) {
                    this.setState({ survey, status: PageStatus.Loaded });
                }
            })
            .catch((error) => {
                this.setState({ status: PageStatus.Error, error: error.message });
            });
    }

    render() {
        const lang = this.props.language ?? 'en';
        return (
            <Modal
                centered
                size="lg"
                backdrop="static"
                onHide={this.props.onClose}
                show
                style={{ zIndex: 1201 }}
            >
                <Modal.Header closeButton>
                    <h5 className="mb-0 mt-1">{panelistDetailsDict[lang]["Panelist Details"] || "Panelist Details"}</h5>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '78vh', overflow: 'auto' }}>
                    <Show when={this.state.status === PageStatus.Loading}>
                        <div className="d-flex justify-content-center w-100 p-5">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    </Show>

                    <Show when={this.state.status === PageStatus.Loaded && !!this.state.survey}>
                        <div className="row mt-2">
                            <div className="col">
                                <strong>{panelistDetailsDict[lang]["Survey Name"] || "Survey Name"}: </strong>
                                {this.state.survey?.survey.name}
                            </div>
                            <div className="col">
                                <strong>{panelistDetailsDict[lang]["Expiry Date"] || "Expiry Date"}: </strong>
                                {formatDate(this.state.survey?.expiryDate)}
                            </div>
                        </div>

                        <div className="row mt-2">
                            <div className="col">
                                <strong>{panelistDetailsDict[lang]["Status"] || "Status"}: </strong>
                                {this.state.survey?.status}
                            </div>
                        </div>

                        <div className="row mt-2">
                            <div className="col">
                                <strong>{panelistDetailsDict[lang]["Description"] || "Description"}: </strong>
                                {this.state.survey?.survey.description}
                            </div>
                        </div>

                        <Alert
                            variant="danger"
                            show={this.state.status === PageStatus.Error}
                        >
                            {this.state.error}
                        </Alert>
                    </Show>
                </Modal.Body>
            </Modal>
        );
    }
}

const PanelistDetailsWithRouter = withRouter(PanelistDetails);

export { PanelistDetailsWithRouter as PanelistDetails };
